import { render, staticRenderFns } from "./ResumoMedia.vue?vue&type=template&id=7edd9a67&"
import script from "./ResumoMedia.vue?vue&type=script&lang=js&"
export * from "./ResumoMedia.vue?vue&type=script&lang=js&"
import style0 from "./ResumoMedia.vue?vue&type=style&index=0&id=7edd9a67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports